export default __webpack_public_path__ + "static/media/logoTmovPayGreen.0a0517e8.svg";